"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var lodash_1 = require("lodash");
var sortFieldsByIndicesAndRemoveIndices = function (schema) { return (__assign(__assign({}, schema), { fields: Object.keys(schema.fields)
        .reduce(function (order, fieldKey) {
        order[schema.fields[fieldKey].index] = fieldKey;
        return order;
    }, [])
        .reduce(function (newFields, fieldKey) {
        newFields[fieldKey] = lodash_1.omit(schema.fields[fieldKey], 'index');
        return newFields;
    }, {}) })); };
module.exports = sortFieldsByIndicesAndRemoveIndices;
//# sourceMappingURL=sortFieldsByIndicesAndRemoveIndices.js.map